import React from 'react';
import { Select } from 'antd';
import type { SelectProps } from 'antd';
import { FONT_FAMILY_OPTIONS } from './styleEditorConstants';
import { hasFontFamilyValue, resolveFontFamily } from '../../utils/fontFamily';

type Props = SelectProps;

export const FontFamilySelect = React.forwardRef<any, Props>(function FontFamilySelect(
  { className, style, ...rest },
  ref,
) {
  const value = rest.value;
  const hasFont = hasFontFamilyValue(value);
  const resolved = hasFont ? resolveFontFamily(String(value)) : undefined;

  return (
    <Select
      ref={ref}
      size="small"
      allowClear
      placeholder="Font"
      className={['word-ribbon-font-select', hasFont ? 'word-ribbon-font-select--active' : '', className]
        .filter(Boolean)
        .join(' ')}
      style={{
        ...style,
        ...(resolved ? { fontFamily: resolved } : {}),
      }}
      popupMatchSelectWidth={false}
      options={FONT_FAMILY_OPTIONS.map((opt) => ({
        ...opt,
        label: (
          <span style={opt.value ? { fontFamily: resolveFontFamily(String(opt.value)) } : undefined}>
            {opt.label}
          </span>
        ),
      }))}
      {...rest}
    />
  );
});
